export const ScriptHandler = (scriptsArray) => {
    if (process.env.REACT_APP_ACCESS_LOCAL_FILE === 'false') {
        loadScriptsSequentially(scriptsArray)
            .then(() => {})
            .catch((error) => {
                console.error('Error loading scripts:', error);
            });
    } else if (process.env.REACT_APP_ACCESS_LOCAL_FILE === 'true') {
        // import('../../../helpers/symlink/common.js');
        // import('../../../helpers/symlink/editor.js');
        // import('../../editor/migration/tenant_lib.min.js');
    }
};

function loadScriptsSequentially(urls) {
    return urls.reduce((chain, url) => {
        return chain.then(() => loadScript(url));
    }, Promise.resolve());
}

function loadScript(url) {
    const existingScript = document.querySelector(`script[src="${url}"]`);
    return new Promise((resolve, reject) => {
        if (existingScript) {
            resolve();
            return;
        }
        const script = document.createElement('script');
        script.src = url;
        script.defer = true;
        script.async = true;
        script.onload = () => {
            // if (url?.includes('common.js')) {
            //     setTimeout(() => window?.editorAndOutputLib && window.editorAndOutputLib(), 2000);
            // } else if (url?.includes('editor.js')) {
            //     setTimeout(() => window?.editorOnlyLib && window.editorOnlyLib(), 2000);
            // }
            resolve();
        };
        script.onerror = reject;
        script.nonce = '2646294A404E6352';
        script.async = true;
        document.getElementsByTagName('body')[0].appendChild(script);
    });
}

export const RemoveOldScriptAndLink = () => {
    let commonJsFile = document.querySelectorAll(`script[src*="/ui/js/"]`);
    let commonCssFile = document.querySelectorAll(`link[href*="/ui/css/"]`);
    for (let i = 0; i < commonJsFile.length; i++) {
        commonJsFile[i].remove();
    }
    for (let i = 0; i < commonCssFile.length; i++) {
        commonCssFile[i].remove();
    }
};

export const RemoveTenantStyleSheet = () => {
    const ui = document.querySelectorAll(`link[href*="/ui"]`);
    if (ui?.length > 0) {
        for (let i = 0; i < ui?.length; i++) {
            ui[i].remove();
        }
    }
    const tenantStyleSheet = document.querySelectorAll(`link[href*="/tenantStylesheet"]`);
    if (tenantStyleSheet.length > 0) {
        for (let i = 0; i < tenantStyleSheet.length; i++) {
            tenantStyleSheet[i].remove();
        }
    }
};
